// extracted by mini-css-extract-plugin
export default {"container":"TableCellWithRightArrow_container__AvasF"};